export default __webpack_public_path__ + "static/media/slide15.ef83add3.jpg";